import toast from "react-hot-toast";
import { customDateFormatType, formatNumber } from "../../utils/utils";
import { formatDateDb } from "../../utils/tools";

const { clientAPI } = require("../client");
export const commissionAnalystCall = {
  export: async (entries, param) => {
    try {
      const options = {
        limit: entries,
        page: 1,
      };

      if (param.search) options.search = param.search;
      if (param.projectId) options.projectId = param.projectId;
      if (param.employeeId) options.approverConfirmId = param.employeeId;

      const queryParams = new URLSearchParams(options).toString();
      const response = await clientAPI("get", `/locking?${queryParams}`);

      const dataExport = response?.items.map((item, index) => {
        let status = "";
        if (item?.confirmCommissionStatus === "NEW") {
          status = "Đang chờ duyệt";
        } else if (item?.confirmCommissionStatus === "APPROVED") {
          status = "Đã duyệt";
        } else {
          status = "Không được duyệt";
        }

        return {
          code: item?.code || "",
          confirmCommissionStatus: item?.confirmCommissionStatus ? status : "-",
          saleOpeningEvent: item?.saleOpeningEvent?.name || "-",
          project: item?.project?.name || "-",
          priceForCommission: item?.apartment?.priceForCommission
            ? `${formatNumber(item?.apartment?.priceForCommission)} VNĐ`
            : "0 VNĐ",
          serviceFeeType: item?.serviceFee?.name || "-",
          approver: item?.approverConfirm?.fullName || "-",
          lockingParticipant:
            item?.lockingParticipant
              ?.map((p) => p?.employee?.fullName)
              .filter(Boolean)
              .join(", ") || "-",
          bookingTime: item?.bookingTime
            ? formatDateDb(item?.bookingTime)
            : "-",
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  bulkAdd: async (input, saleOpeningEventId, dataKRateId, name) => {
    try {
      const data = {
        input,
        name,
        saleOpeningEventId,
        dataKRateId,
      };
      const response = await clientAPI(
        "post",
        "/commissionAnalyst/bulkMany/",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  bulkCalculator: async (input, saleOpeningEventId, dataKRateId, name) => {
    try {
      const data = {
        input,
        name,
        saleOpeningEventId,
        dataKRateId,
      };
      const response = await clientAPI(
        "post",
        "/commissionAnalyst/bulkCalculator/",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  bulkManyCheck: async (input, saleOpeningEventId, dataKRateId, name) => {
    try {
      const data = {
        input,
        name,
        saleOpeningEventId,
        dataKRateId,
      };
      const response = await clientAPI(
        "post",
        "/commissionAnalyst/bulkManyCheck/",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  bulkCalculatorCheck: async (input, saleOpeningEventId, dataKRateId, name) => {
    try {
      const data = {
        input,
        name,
        saleOpeningEventId,
        dataKRateId,
      };
      const response = await clientAPI(
        "post",
        "/commissionAnalyst/bulkCalculatorCheck/",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  checkPDVExcel: async ({ month, year, mainTabRows, theoCanRows }) => {
    try {
      const response = await clientAPI("post", "/commissionAnalyst/checkPDVExcel/", {
        month,
        year,
        mainTabRows,
        theoCanRows,
      });
      return response;
    } catch (error) {
      console.error("checkPDVExcel error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];
      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  deleteCommission: async (input, name) => {
    try {
      const data = {
        input,
        name,
      };
      const response = await clientAPI(
        "post",
        "/commissionAnalyst/deleteCommission/",
        data,
      );
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },

  exportCommissionAnalyst: async (param) => {
    try {
      const options = {};

      if (param.search !== undefined) options.search = param.search;
      if (param.projectId?.length) options.projectId = param.projectId;
      if (param.bookerId) options.bookerId = param.bookerId;
      if (param.lockingEventId) options.lockingEventId = param.lockingEventId;
      if (param.status?.length) options.status = param.status;
      if (param.isTtkqHdmbs) options.isTtkqHdmbs = param.isTtkqHdmbs;
      if (param.apartmentId?.length) options.apartmentId = param.apartmentId;
      if (param.customerId) options.customerId = param.customerId;
      if (param.startTime)
        options.startTime = customDateFormatType(param.startTime);
      if (param.endTime) options.endTime = customDateFormatType(param.endTime);
      if (param.saleBlockId) options.saleBlockId = param.saleBlockId;
      if (param.saleAreaId) options.saleAreaId = param.saleAreaId;
      if (param.startCalculate) options.startCalculate = param.startCalculate;
      if (param.startTimeCreated)
        options.startTimeCreated = customDateFormatType(param.startTimeCreated);
      if (param.endTimeCreated)
        options.endTimeCreated = customDateFormatType(param.endTimeCreated);
      if (param.inputLate) options.inputLate = param.inputLate;
      if (param.confirmCommissionStatus)
        options.confirmCommissionStatus = param.confirmCommissionStatus;
      if (param.approveTransaction)
        options.approveTransaction = param.approveTransaction;

      const queryParams = new URLSearchParams(options).toString();

      const response = await clientAPI(
        "get",
        `/commissionAnalyst/export?${queryParams}`,
      );

      const dataExport = response?.items.map((item, index) => {
        return {
          project: item?.project,
          transactionDate: item?.transactionDate
            ? formatDateDb(item?.transactionDate)
            : "",
          saleOpeningEvent: item?.saleOpeningEvent || "-",
          product: item?.product,
          customer: item?.customer,
          totalValue: item?.totalValue,
          price: item?.price,
          priceForCommission: item?.priceForCommission,
          standardWorkingDaysInMonth: item?.standardWorkingDaysInMonth,
          transactionRate: item?.transactionRate,
          incomeRate: item?.incomeRate,
          platformIncomeRate: item?.platformIncomeRate,

          commissionRate1: item?.commissionRate1,
          sale1: item?.sale1,
          code1: item?.code1,
          // jobTitle1: item?.jobTitle1,
          workingDays1: item?.workingDays1,
          codeCTV1: item?.codeCTV1,
          codeGDK1: item?.codeGDK1,
          nameGDK1: item?.nameGDK1,
          workingDaysGDK1: item?.workingDaysGDK1,
          codeGDV1: item?.codeGDV1,
          nameGDV1: item?.nameGDV1,
          workingDaysGDV1: item?.workingDaysGDV1,
          commissionRate2: item?.commissionRate2,
          sale2: item?.sale2,
          code2: item?.code2,
          // jobTitle2: item?.jobTitle2,
          workingDays2: item?.workingDays2,
          codeCTV2: item?.codeCTV2,
          codeGDK2: item?.codeGDK2,
          nameGDK2: item?.nameGDK2,
          workingDaysGDK2: item?.workingDaysGDK2,
          codeGDV2: item?.codeGDV2,
          nameGDV2: item?.nameGDV2,
          workingDaysGDV2: item?.workingDaysGDV2,
        };
      });

      return dataExport;
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  exportCalculator: async (param) => {
    try {
      const options = {};

      if (param.projectId?.length) options.projectId = param.projectId;
      if (param.bookerId) options.bookerId = param.bookerId;
      if (param.saleOpeningEventId)
        options.saleOpeningEventId = param.saleOpeningEventId;
      if (param.apartmentId?.length) options.apartmentId = param.apartmentId;
      if (param.customerId) options.customerId = param.customerId;
      if (param.startTime)
        options.startTime = customDateFormatType(param.startTime);
      if (param.endTime) options.endTime = customDateFormatType(param.endTime);
      if (param.saleBlockId) options.saleBlockId = param.saleBlockId;
      if (param.saleAreaId) options.saleAreaId = param.saleAreaId;
      if (param.startCalculate) options.startCalculate = param.startCalculate;
      if (param.startTimeCreated)
        options.startTimeCreated = customDateFormatType(param.startTimeCreated);
      if (param.endTimeCreated)
        options.endTimeCreated = customDateFormatType(param.endTimeCreated);
      if (param.startCalculatorTime)
        options.startCalculatorTime = customDateFormatType(
          param.startCalculatorTime,
        );
      if (param.endCalculatorTime)
        options.endCalculatorTime = customDateFormatType(
          param.endCalculatorTime,
        );
      if (param.reconciliationMonthDate) {
        const d = new Date(param.reconciliationMonthDate);
        options.reconciliationMonth = d.getMonth() + 1;
        options.reconciliationYear = d.getFullYear();
      }

      const queryString = new URLSearchParams(options).toString();
      const url = queryString
        ? `/commissionAnalyst/exportCalculator?${queryString}`
        : `/commissionAnalyst/exportCalculator`;

      const response = await clientAPI("get", url);

      return {
        dataExport: response?.dataExport || [],
        dataExport2: response?.dataExport2 || [],
        dataExport3: response?.dataExport3 || [],
        uniqueSaleOpeningEvents: response?.uniqueSaleOpeningEvents || [],
      };
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => toast.error(`${message}`));
      throw error;
    }
  },
  exportCalculatorEstimate: async (param) => {
    try {
      const options = {};

      if (param.projectId?.length) options.projectId = param.projectId;
      if (param.bookerId) options.bookerId = param.bookerId;
      if (param.saleOpeningEventId)
        options.saleOpeningEventId = param.saleOpeningEventId;
      if (param.apartmentId?.length) options.apartmentId = param.apartmentId;
      if (param.customerId) options.customerId = param.customerId;
      if (param.startTime)
        options.startTime = customDateFormatType(param.startTime);
      if (param.endTime) options.endTime = customDateFormatType(param.endTime);
      if (param.saleBlockId) options.saleBlockId = param.saleBlockId;
      if (param.saleAreaId) options.saleAreaId = param.saleAreaId;
      if (param.startCalculate) options.startCalculate = param.startCalculate;
      if (param.startTimeCreated)
        options.startTimeCreated = customDateFormatType(param.startTimeCreated);
      if (param.endTimeCreated)
        options.endTimeCreated = customDateFormatType(param.endTimeCreated);
      if (param.startCalculatorTime)
        options.startCalculatorTime = customDateFormatType(
          param.startCalculatorTime,
        );
      if (param.endCalculatorTime)
        options.endCalculatorTime = customDateFormatType(
          param.endCalculatorTime,
        );

      const queryString = new URLSearchParams(options).toString();
      const url = queryString
        ? `/commissionAnalyst/exportCalculatorEstimate?${queryString}`
        : `/commissionAnalyst/exportCalculatorEstimate`;

      const response = await clientAPI("get", url);

      return {
        dataExport: response?.dataExport || [],
        dataExport2: response?.dataExport2 || [],
        dataExport3: response?.dataExport3 || [],
        uniqueSaleOpeningEvents: response?.uniqueSaleOpeningEvents || [],
      };
    } catch (error) {
      console.error("get list error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message,
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => toast.error(`${message}`));
      throw error;
    }
  },
};
